<template>
  <b-container>
    <b-card>
      <b-card-text>Content</b-card-text>

      <b-form @submit="saveChanges">
        <b-row>
          <b-col
            sm="12"
            class="mb-3"
          >
            <quill-editor
              v-model="content"
              :options="snowOption"
            />
          </b-col>
          <b-col class="d-flex justify-content-end">
            <b-button
              type="button"
              class="mr-1"
              variant="light"
            >
              Cancel
            </b-button>
            <b-button
              type="submit"
              :disabled="isLoading"
              variant="primary"
            >
              Save
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import {
  BRow, BCol, BContainer, BCard, BButton, BForm,
  BCardText,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BContainer,
    BCard,
    BButton,
    BForm,
    quillEditor,
    BCardText,
  },

  data() {
    return {
      isLoading: false,
      content: '',
      snowOption: {
        theme: 'snow',
      },
    }
  },

  mounted() {
    this.fetchSettings()
  },

  methods: {
    fetchSettings() {
      this.$http.get('/settings/terms-of-use')
        .then(res => {
          this.content = res.data.data.content
        })
        .catch(err => { this.$notif('Error', `${err.message}`, 'error') })
    },

    saveChanges(event) {
      event.preventDefault()
      this.isLoading = true

      this.$http.post('/settings/terms-of-use', {
        content: this.content,
      })
        .then(() => {
          this.$notif('Success', 'Terms Of Use settings has been successfully updated.', 'success')
          this.fetchSettings()
        })
        .catch(err => { this.$notif('Error', `${err.message}`, 'error') })
        .finally(() => { this.isLoading = false })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>
